import React from "react";
import {
  ResponsiveSelect,
  SelectSheetOption,
} from "../../../../components/MobileForm";
import { InlineToggle } from "../../../../components/InlineToggle";
import { ActiveFilterOption, AccountsFiltersProps } from "../types";
import { FiltersWrapper, FilterGroup, FilterCount } from "./styles";

export const AccountsFilters: React.FC<AccountsFiltersProps> = ({
  isCompact,
  years,
  yearSelected,
  onYearChange,
  activeOnly,
  onActiveChange,
  resultCount,
}) => {
  const countLabel =
    resultCount === 1 ? "1 account" : `${resultCount} accounts`;

  const handleToggle = (value: boolean) => {
    const next: ActiveFilterOption = {
      label: value ? "Yes" : "No",
      value,
    };
    onActiveChange(next);
  };

  const yearOptions: SelectSheetOption[] = years.map((year) => ({
    label: year.label,
    value: String(year.value),
  }));

  const handleYearChange = (option: SelectSheetOption) => {
    const match = years.find((year) => String(year.value) === option.value);
    if (match) {
      onYearChange(match);
    }
  };

  return (
    <FiltersWrapper role="search" aria-label="Filter accounts">
      <FilterGroup>
        <ResponsiveSelect
          isCompact={isCompact}
          options={yearOptions}
          value={String(yearSelected.value)}
          onChange={handleYearChange}
          sheetTitle="Select year"
          testId="accounts-year-filter"
        />
        <InlineToggle
          checked={activeOnly.value}
          onChange={handleToggle}
          label="Active only"
          ariaLabel="Show active accounts only"
          testId="accounts-active-filter"
        />
      </FilterGroup>
      <FilterCount role="status" aria-live="polite">
        {countLabel}
      </FilterCount>
    </FiltersWrapper>
  );
};
